

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GlobalErrorModalService {
  private modalState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public modalStateObs = this.modalState.asObservable();
  public errMessage: string = '';
  public errTrace: string = '';

  public open(error): void {
    this.errMessage = error.message;
    this.errTrace = error.traceId;
    this.modalState.next(true);
  }

  public close(): void {
    this.modalState.next(false);
    this.errTrace = '';
    this.errMessage = '';
  }
}
